import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { CreatePermissionViewModel } from 'src/app/viewModels/permissions/createPermissionViewModel/create-permission-view-model';
import { UpdatePermissionViewModel } from 'src/app/viewModels/permissions/updatePermissionViewModel/update-permission-view-model';
import { DeletePermissionViewModel } from 'src/app/viewModels/permissions/deletePermissionViewModel/delete-permission-view-model';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiendPointsPermission } from '../../common/apiUrls/apiend-points';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private baseUrl:any;
  constructor(@SkipSelf()private _http: HttpClient, private apiAddress: ApiendPointsPermission,
    public env: EnvService, private constant: Constants) {

      
if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
this.baseUrl = this.constant.PermissionPortNumber;
else
this.baseUrl = this.env.apiUrl+this.constant.PermissionPortNumber;

     } 
  //private baseUrl = this.constant.PermissionPortNumber;
  //private baseUrl = this.env.apiUrl+this.constant.PermissionPortNumber;

  //Summary
  //Pagination values will be send as request parameters.
  //Get the Permissions available for listing.
  getAllPermissions(paginationVM: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getPermissionsApiUrl;
    return this._http.post(apiCallingURl, paginationVM).pipe();
  }

  //Summary
  //CreatePermissionViewModel will be send as request parameters.
  //Create new Permissions.
  createPermission(createPermissionVM: CreatePermissionViewModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.createPermissionApiUrl;
    return this._http.post(apiCallingURl, createPermissionVM).pipe();
  }

  //Summary
  //CreatePermissionViewModel will be send as request parameters.
  //Create new Permissions.
  getModuleList(paginationVM: PaginationViewModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getModuleList;
    return this._http.post(apiCallingURl, paginationVM).pipe();
  }

  //Summary
  //UpdatePermissionViewModel will be send as request parameters.
  //Update the Permissions available on the basis of Id.
  updatePermission(updatePermissionVM: UpdatePermissionViewModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.updatePermissionApiUrl;
    return this._http.post(apiCallingURl, updatePermissionVM).pipe();
  }

  //Summary
  //UpdatePermissionViewModel will be send as request parameters.
  //Update the Permissions available on the basis of Id.
  deletePermission(deletePermissionVM: DeletePermissionViewModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.deletePermissionApiUrl;
    return this._http.post(apiCallingURl, deletePermissionVM).pipe();
  }

}
